import React from 'react';
import CloseButton from '../button/CloseButton';

interface ErrorMessageProps {
    message: string
    onClose: () => void;
    mode?: 'error' | 'warning'
}

const ErrorMessage = ({message, onClose, mode = 'error'}: ErrorMessageProps) => {
  return (
    <div
      className={`alert ${mode === 'warning' ? 'alert-warning' : 'alert-danger'} u-mb-2`}
      role='alert'
    >
      {/* Flex row rather than Bootstrap's `alert-dismissible` (which absolutely positions
          its own `.btn-close`), because the shared CloseButton positions itself with
          `margin-left: auto`. */}
      <div className='d-flex align-items-start'>
        <div className='flex-grow-1'>{message}</div>
        <CloseButton onClick={onClose} />
      </div>
    </div>
  )
};

export default ErrorMessage
